import { render, staticRenderFns } from "./AggregationsModal.vue?vue&type=template&id=a92badce&"
import script from "./AggregationsModal.vue?vue&type=script&lang=js&"
export * from "./AggregationsModal.vue?vue&type=script&lang=js&"
import style0 from "./AggregationsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports